import clsxm from "@/lib/clsxm";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const BetaChip: FC<{className?: string}> = ({className}) => {
  const {t} = useTranslation("common");

  return (
    <span
      className={clsxm(
        "bg-neutral-black text-2xs flex min-h-4 items-center rounded-full px-1 leading-3.5 font-bold tracking-wider text-white uppercase",
        className,
      )}>
      {t("beta")}
    </span>
  );
};

export default BetaChip;
